// Temporary solution for env behavior.
export const isLocal = window.location.href.includes('//localhost');
export const isDev: boolean = window.location.href.includes('//admin.flowdx.xyz/');
export const isProd = !isLocal && !isDev;
export const EnvName = isLocal ? 'local' : isDev ? 'dev' : 'prod';
